import state from './state'

export default {
  computed: {
    posts: function () {
      return this._get(state.project.id) ? this.$store.getters.projectPosts(this._get(state.project.id), this.isSortedNewestFirst) || [] : []
    },
    numPosts: function () {
      return this._get(state.posts.total) || 0
    },
    postLoading: function () {
      return this._get(state.posts.loading, false)
    },
    project: function () {
      return this._get(state.project.id) ? this.$store.getters.project(this._get(state.project.id)) || {} : {}
    },
    projectQRLink: function () {
      return this._get(state.project.qrLink) ? this.$store.getters.projects[this._get(state.project.id)].qrLink : null
    },
    canCreatePost: function () {
      return this._get(state.posts.permissions.create, false)
    },
    canEditProject: function () {
      return this._get(state.project.permissions.edit, false)
    },
    targetCommentID: function () {
      return this.$route ? parseInt(this.$route.query.commentID) : 0
    },
    isSortedNewestFirst: function () {
      return !this._get(state.project.defaultFirstToLast, false) && this._get(state.posts.sortNewest, false)
    },
    repliesExpanded: function () {
      return this._get(state.posts.repliesExpanded, false)
    }
  },
  methods: {
    fetch: function () {
      this._callback(state.posts.fetch)
    }
  }
}
